import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import api from "../../lib/api";

export default function ClientQuote() {
  const [quotes, setQuotes] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get("/public/site/quotes").then((r) => setQuotes(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (quotes.length < 2) return undefined;
    const t = setInterval(() => setI((n) => (n + 1) % quotes.length), 8000);
    return () => clearInterval(t);
  }, [quotes.length, i]);
  const q = quotes[i];
  if (!q) return null;
  const by = [q.designation, q.organisation].filter(Boolean).join(", ");
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-16" data-testid="home-client-quote">
      <figure className="relative border-t border-white/10 pt-10 grid lg:grid-cols-12 gap-8 items-start">
        <Quote className="lg:col-span-1 h-10 w-10 text-[#C4A66A] -scale-x-100" strokeWidth={1.25} aria-hidden="true" />
        <div className="lg:col-span-11">
          <blockquote key={q.id} className={`font-serif italic text-2xl lg:text-[2rem] leading-snug text-white/90 max-w-4xl site-reveal ${quotes.length > 1 ? "min-h-[7.5em] lg:min-h-[5em]" : ""}`} data-testid="client-quote-text">
            {q.quote}
          </blockquote>
          <figcaption className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="h-px w-10 bg-[#C4A66A]" />
            {q.name && <span className="text-sm font-semibold text-white" data-testid="client-quote-name">{q.name}</span>}
            {by && <span className="text-[11px] uppercase tracking-[0.22em] text-white/50" data-testid="client-quote-by">{by}</span>}
            {quotes.length > 1 && (
              <span className="ml-auto flex gap-2" data-testid="client-quote-dots">
                {quotes.map((x, n) => (
                  <button key={x.id} onClick={() => setI(n)} aria-label={`Quote ${n + 1}`} className={`h-1.5 transition-[width,background-color] duration-300 ${n === i ? "w-8 bg-[#C4A66A]" : "w-3 bg-white/25 hover:bg-white/50"}`} />
                ))}
              </span>
            )}
          </figcaption>
        </div>
      </figure>
    </div>
  );
}
